/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 17 2024
 **/

import parse from "html-react-parser";

import { Typography } from "@/frameworks/designStuff/components";
import { useMouseEnterWait } from "@/frameworks/libraries/hooks";
import { GROUP_POPOVER_ID } from "@/frameworks/core/commons";
import { usePopover } from "@/frameworks/core/hooks";
import { MiniProfile } from "@/frameworks/core/components";

export default function User({ name, id }: ChatServices.Format2.Elements.User) {
	const popover = usePopover();

	const { ref } = useMouseEnterWait<HTMLSpanElement>((ev) => {
		if (id === "@all") return;
		const target = ev.target as HTMLSpanElement;
		const { top, left } = target.getBoundingClientRect();
		popover.show({
			popoverID: GROUP_POPOVER_ID.AVATAR_MINI_PROFILE,
			uniqueID: id,
			content: (
				<div onMouseLeave={() => popover.hide(GROUP_POPOVER_ID.AVATAR_MINI_PROFILE)}>
					<MiniProfile userID={id} />
				</div>
			),
			zIndex: 99999,
			anchorEl: document.body,
			position: {
				x: left,
				y: top
			}
		});
	});

	// 채팅 검색에서 강조되는 영역을 span 태그로 감싸고 있기 때문에 html parser 추가함
	return (
		<Typography
			ref={ref}
			typoSize="Title2"
			typoColor="accent_40_100"
			css={{ cursor: id === "@all" ? "default" : "pointer" }}
		>
			@{parse(name)}
		</Typography>
	);
}
